import * as PropTypes from 'prop-types';
import React from 'react';

function ConfigureStep(props: ConfigureStepProps): JSX.Element {
  return (
    <div className="configureStep-container">
      <div className="configureStep-header">
        <div className="configureStep-step">{props.stepNumber}</div>
        <div className="configureStep-title">{props.title}</div>
      </div>
      <div>{props.children}</div>
    </div>
  );
}

interface ConfigureStepProps {
  stepNumber: number;
  title: string;
  children: Array<JSX.Element> | JSX.Element | null;
}

ConfigureStep.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default ConfigureStep;
